<div class="filter-container">
  <app-button [button]="showFiltersButton"> </app-button>
</div>

<ng-container *ngIf="cards[0] && cards[0]!.items.length === 0; else cardList">
  <div class="no-result-message">
    <div>No Result Found!</div>
  </div>
</ng-container>

<ng-template #cardList>
  <div *ngIf="!loading">
    <div class="filters"></div>
    <app-card [items]="cards"></app-card>

    <div class="load-more-container" *ngIf="!isListEmpty">
      <app-button [button]="loadMoreButton"> </app-button>
    </div>
  </div>

  <ng-container *ngIf="loading">
    <div class="shimmer-container">
      <app-shimmer
        *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      ></app-shimmer>
    </div>
    >
  </ng-container>
</ng-template>

<!--Filters-->
<app-filter [items]="filterItems"> </app-filter>
